module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('data-form', {
    attrs: {
      "entity": _vm.filters,
      "fields": _vm.fields,
      "hideButtons": true
    },
    on: {
      "change": _vm.filtersChanged
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-52b28110!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/event/EventTableConfig.vue
// module id = 1156
// module chunks = 2